import {
  validationSchema as purposeValidationSchema,
  fieldNames as purposeFieldNames,
} from 'components/PurposeModal/flag.on/data'
import {
  validationSchema as programStartDateValidationSchema,
  fieldNames as programStartDateFieldNames,
} from 'components/ProgramStartDateModal/data'
import {
  validationSchema as goalsValidationSchema,
  fieldNames as goalsFieldNames,
} from 'components/GoalsModal/flag.on/data'
import {
  validationSchema as implementationApproachValidationSchema,
  fieldNames as implementationApproachFieldNames,
} from 'components/ImplementationApproachModal/flag.on/data'

export const validationSchema = implementationApproachValidationSchema
  .concat(goalsValidationSchema)
  .concat(purposeValidationSchema)
  .concat(programStartDateValidationSchema)

export const fieldNameSets = [
  [],
  implementationApproachFieldNames,
  purposeFieldNames,
  goalsFieldNames,
  programStartDateFieldNames,
]
